import { Link } from 'react-router-dom';
import { Input, InputGroup } from 'reactstrap';
import { Btn, H6 } from '../../../../AbstractElements';
import { Apply, CheckOut, ContinueShopping, TotalPrice } from "../../../../Constants/Constants";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { getallCardTotal } from '../../../../Utils/Ecommerce.service';

const CartAction = () => {
  const { cart } = useAppSelector((state) => state.cartData);
  const { symbol } = useAppSelector((state) => state.product);
  
  return (
    <>
      <tr>
        <td colSpan={4}>
          <InputGroup>
            <Input className="me-2" type="text" placeholder="Enter coupan code"/>
            <Btn color='primary' className="text-white">{Apply}</Btn>
          </InputGroup>
        </td>
        <td className="total-amount">
          <H6 className= "m-0 text-end" ><span className="f-w-600">{TotalPrice} :</span></H6>
        </td>
        <td><span>{symbol}{getallCardTotal(cart)}</span></td>
      </tr>
      <tr>
        <td className="text-end" colSpan={5}><Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`} className="btn btn-secondary cart-btn-transform">{ContinueShopping}</Link></td>
        <td><Link className="btn btn-success cart-btn-transform" to={`${process.env.PUBLIC_URL}/applications/ecommerce/checkout`}>{CheckOut}</Link></td>
      </tr>
    </>
  );
};

export default CartAction;
